import React from "react";
import { Row, Col } from "reactstrap";
import favicon from "../../../assets/images/favicon.png";
import styles from "../css/clinicalActivityLanding.module.scss";
import { useClinicalActivity, ScanningActivityType } from "../hooks/useClinicalActivity";

interface ClinicalActivityLandingProps {
  onSelectActivity: (activity: ScanningActivityType) => void;
  handleLogout: () => void;
}

const ClinicalActivityLanding: React.FC<ClinicalActivityLandingProps> = ({
  onSelectActivity,
  handleLogout,
}) => {
  const { userName, handleChooseActivity } = useClinicalActivity(onSelectActivity);

  return (
    <div className={styles.landingWrapper}>
      {/* ── Top Bar Header ── */}
      <div className={styles.topHeader}>
        <div className={styles.brandGroup}>
          <img src={favicon} alt="Vista Logo" />
          <h5 className={styles.brandTitle}>Accessioning Session</h5>
        </div>

        <div className={styles.userBadge}>
          <div className={styles.userInfo}>
            <i className="ri-user-3-line"></i>
            <span>{userName}</span>
          </div>

          <button
            type="button"
            className={styles.logoutBtn}
            onClick={handleLogout}
            title="Logout"
          >
            <i className="ri-logout-box-r-line"></i>
          </button>
        </div>
      </div>

      {/* ── Main Viewport Content ── */}
      <div className={styles.mainContent}>
        {/* <div className={styles.heroHeader}>
          <h2>Select Clinical Activity</h2>
        </div> */}

        {/* ── Activity Choice Grid ── */}
        <Row className={`g-3 ${styles.cardsGrid}`}>
          {/* Card 1: Sample Collection & Aliquotation */}
          <Col md={6} sm={12}>
            <div
              className={`${styles.activityCard} ${styles.sampleCard}`}
              onClick={() => handleChooseActivity("sample_collection")}
            >
              <i className={`ri-flask-line ${styles.watermarkIcon}`}></i>

              <div>
                <div className={styles.cardHeader}>
                  <div className={styles.iconCircle}>
                    <i className="ri-flask-line"></i>
                  </div>
                </div>

                <h4 className={styles.cardTitle}>Sample Collection &amp; Aliquotation</h4>
                <p className={styles.cardDesc}>
                  Collect biological samples (blood/urine) and process aliquots for the study.
                </p>

                <div className={styles.featuresList}>
                  <div className={styles.featureBox}>
                    <div className={styles.featureIconCircle}>
                      <i className="ri-barcode-box-line"></i>
                    </div>
                    <span>Scan subject wristband &amp; vacutainer</span>
                  </div>

                  <div className={styles.featureBox}>
                    <div className={styles.featureIconCircle}>
                      <i className="ri-drop-line"></i>
                    </div>
                    <span>Record collection details in real time</span>
                  </div>

                  <div className={styles.featureBox}>
                    <div className={styles.featureIconCircle}>
                      <i className="ri-[#2563eb] ri-test-tube-line"></i>
                    </div>
                    <span>Support for pre-dose and post-dose samples</span>
                  </div>
                </div>
              </div>

              <button type="button" className={styles.actionBtn}>
                <span>Start Sample Collection</span>
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </Col>

          {/* Card 2: IP Dosing (Drug Administration) */}
          {/* <Col md={6} sm={12}>
            <div
              className={`${styles.activityCard} ${styles.dosingCard}`}
              onClick={() => handleChooseActivity("dosing")}
            >
              <i className={`ri-capsule-line ${styles.watermarkIcon}`}></i>

              <div>
                <div className={styles.cardHeader}>
                  <div className={styles.iconCircle}>
                    <i className="ri-capsule-line"></i>
                  </div>
                </div>

                <h4 className={styles.cardTitle}>IP Dosing (Drug Administration)</h4>
                <p className={styles.cardDesc}>
                  Administer investigational product (IP) at the scheduled dose time.
                </p>

                <div className={styles.featuresList}>
                  <div className={styles.featureBox}>
                    <div className={styles.featureIconCircle}>
                      <i className="ri-user-follow-line"></i>
                    </div>
                    <span>Scan subject wristband</span>
                  </div>

                  <div className={styles.featureBox}>
                    <div className={styles.featureIconCircle}>
                      <i className="ri-qr-scan-2-line"></i>
                    </div>
                    <span>Scan IP barcode</span>
                  </div>

                  <div className={styles.featureBox}>
                    <div className={styles.featureIconCircle}>
                      <i className="ri-checkbox-circle-line"></i>
                    </div>
                    <span>Confirm dose administration with time stamp</span>
                  </div>
                </div>
              </div>

              <button type="button" className={styles.actionBtn}>
                <span>Start IP Dosing</span>
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </Col> */}
        </Row>
      </div>
    </div>
  );
};

export default ClinicalActivityLanding;
